import type { ColumnDef } from '@tanstack/react-table';
import type { File } from '../../../../types/file.types';
import { RiskStatus } from '@/components/ui/RiskStatus';
import { SortIcons } from '../FileListTable/SortIcons';

export const RiskColumn: ColumnDef<File> = {
  id: 'risque',
  accessorFn: (row) => row.risque,
  header: ({ column }) => (
    <button
      onClick={() => column.toggleSorting()}
      className="flex w-full items-center justify-center gap-1"
    >
      Risque
      <SortIcons sortDirection={column.getIsSorted()} />
    </button>
  ),
  cell: (props) => (
    <div className="flex items-center justify-center">
      <RiskStatus type="LIGHT" risk={Number(props.getValue())} />
    </div>
  ),
  enableSorting: true,
  size: 90,
  minSize: 90,
};
